module.exports = __webpack_public_path__ + "img/michal.5d7cbce.png";